import {
  Baby,
  Users,
  UserRound,
  Laptop,
  School,
  Sprout,
  SlidersHorizontal,
} from "lucide-react";
import { AUDIENCE, AUDIENCE_INTRO } from "../../config/landingConfig";
import { Reveal } from "./Reveal";
import { SectionTag } from "./decorations";

const ICONS = [Baby, Users, UserRound, Laptop, School, Sprout, SlidersHorizontal];

export const Audience = () => (
  <section data-testid="audience-section" className="bg-blush">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-28">
      <Reveal>
        <SectionTag number="07" label="Dla kogo" color="bg-cyan" />
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Dla kogo jest AI Speaking Games?
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-ink/70 sm:text-lg">
          {AUDIENCE_INTRO}
        </p>
      </Reveal>

      <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {AUDIENCE.map((item, i) => {
          const Icon = ICONS[i];
          const last = i === AUDIENCE.length - 1;
          return (
            <Reveal key={item.title} delay={(i % 4) * 0.07} className={last ? "h-full sm:col-span-2" : "h-full"}>
              <li
                data-testid={`audience-card-${i + 1}`}
                className={`hover-lift flex h-full items-start gap-4 rounded-2xl border-2 border-ink p-5 shadow-hard-sm ${last ? "bg-magenta" : "bg-white"}`}
              >
                <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border-2 border-ink text-ink ${last ? "bg-white" : "bg-cyan"}`}>
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <span>
                  <span className={`block text-sm font-extrabold leading-snug sm:text-base ${last ? "text-white" : "text-ink"}`}>
                    {item.title}
                  </span>
                  <span className={`mt-1 block text-sm leading-relaxed ${last ? "text-white/85" : "text-ink/70"}`}>
                    {item.desc}
                  </span>
                </span>
              </li>
            </Reveal>
          );
        })}
      </ul>
    </div>
  </section>
);
